export default __webpack_public_path__ + "static/media/330_business05-en-mobile.89f7b03e.png";